// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — regular-options-checkbox.styled.classic.js, новая — regular-options-checkbox.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './regular-options-checkbox.styled.classic';
import * as cp from './regular-options-checkbox.styled.cp';

export const Place = isCp ? cp.Place : classic.Place;
export const PlaceItem = isCp ? cp.PlaceItem : classic.PlaceItem;
